import { Grid, Stack } from '@mui/material'
import { FC } from 'react'
import { useParams } from 'react-router-dom'
import AddressSchedulerIcon from '../../assets/images/address-scheduler-icon.svg?react'
import AddressChangeSchedulerIcon from '../../assets/images/icons/address-change-scheduler-icon.svg?react'
import IntrusionAlarmReviewIcon from '../../assets/images/intrusion-alarm-review-icon.svg?react'
import MonitoringModerationIcon from '../../assets/images/monitoring-moderation-icon.svg?react'
import { Page } from '../../components/Page'
import { isValidLocationSearchInput } from '../../utils/utils'
import { NotFoundPage } from '../NotFoundPage'
import { AppCardGrid } from './AppCardGrid'

export const LandingPage: FC = () => {
  const { sid: locationId } = useParams()

  if (locationId && !isValidLocationSearchInput(locationId)) {
    return <NotFoundPage />
  }

  const buildAppCardPath = (navItemPath: string) => {
    if (locationId !== undefined) {
      return `/locations/${locationId}/${navItemPath}` as const
    } else {
      return `/locations/${navItemPath}` as const
    }
  }

  return (
    <Page title={'Admin Review Tool'} showChildrenWhenMissingLocation={true} data-testid={'landing-page'}>
      <Stack spacing={'var(--spacing-2xl)'}>
        <Grid container spacing={'var(--spacing-l)'}>
          <AppCardGrid
            name={'Location Management'}
            description={'View and Update Location and Permit Information'}
            // TODO: get a proper icon for location management
            icon={<AddressSchedulerIcon style={{ color: 'var(--text-inverted)' }} />}
            color={'var(--yellow-500)'}
            path={buildAppCardPath('location-management')}
            data-testid={'location-management-app'}
          />
          <AppCardGrid
            name={'Alarm SMS Review'}
            description={'Review Customer SMS for Alarm Incidents'}
            icon={<IntrusionAlarmReviewIcon />} // TODO: Replace with Alarm SMS icon
            color={'var(--red-500)'}
            path={buildAppCardPath('alarm-sms-review')}
            data-testid={'alarm-sms-review-app'}
          />
          <AppCardGrid
            name={'Engagement Review Tool'}
            description={'QA Monitoring Engagements'}
            icon={<IntrusionAlarmReviewIcon />}
            color={'var(--green-500)'}
            path={buildAppCardPath('engagement-review')}
            data-testid={'engagement-review-tool-app'}
          />
          <AppCardGrid
            name={'Address Scheduler'}
            description={'Schedule a Customers Move'}
            // TODO: get a proper icon for address scheduler that doesn't need to have a height and width override to look correct
            icon={<AddressChangeSchedulerIcon style={{ width: '6rem', height: '6rem', color: 'var(--text-inverted)' }} />}
            color="var(--blue-600)"
            path={buildAppCardPath('address-scheduler')}
            data-testid={'address-scheduler-app'}
          />
          <AppCardGrid
            name={'Monitoring Moderation'}
            description={'Manage and Review Camera Moderation Events'}
            icon={<MonitoringModerationIcon />}
            color={'var(--orange-500)'}
            path={buildAppCardPath(locationId ? 'monitoring-moderation/camera-overview' : 'monitoring-moderation')}
            data-testid={'monitoring-moderation-app'}
          />
        </Grid>
      </Stack>
    </Page>
  )
}
